import React, { useState, useEffect } from 'react';
import NavBar from './commonHooks/commonHooks.navBar'; 
import DataService from '../service/service.sql';
import './css/leaderboard.css'

const Leaderboard = () => {
    const [data, setData] = useState(null);
    const [sortBy, setSortBy] = useState(null);
    const [sortOrder, setSortOrder] = useState('asc');

    useEffect(() => {
        const getLeaderboard = async () => {
            try {
                const importedData = await DataService.getAllLeaderboard();
                setData(importedData.data.data);
            } catch (error) {
                console.error("error", error);
            }
        };

        getLeaderboard();
    }, []);

    const handleSort = (columnName) => {
        if (sortBy === columnName) {
            if(sortOrder === 'asc') {
                setSortOrder('desc')
            } else if (sortOrder === 'desc') {
                setSortOrder('asc')
                setSortBy(null)
            }
        } else {
            // Set new column to sort and default to ascending order
            setSortBy(columnName);
            setSortOrder('asc');
        }
    };

    const sortedData = data ? [...data].sort((a, b) => {
        if (sortOrder === 'asc') {
            return a[sortBy] - b[sortBy];
        } else {
            return b[sortBy] - a[sortBy];
        }
    }) : [];

    const getSortIndicator = (columnName) => {
        if (sortBy === columnName) {
            return sortOrder === 'asc' ? '↑' : ' ↓';
        }
        return '';
    };

    return (
        <>
            <NavBar />
            <div className='leaderboard-text'>
                <h5>To filter, click on any of the headers.</h5>
            </div>
            <table className='leaderboard-table'>
                <thead>
                    <tr>
                        <th className='user'>User</th>
                        <th onClick={() => handleSort('score')}>Score {getSortIndicator('score')}</th>
                        <th onClick={() => handleSort('clearPercent')}>Clear Percent {getSortIndicator('clearPercent')}</th>
                        <th onClick={() => handleSort('clearPercentAlive')}>Clear Percent Alive {getSortIndicator('clearPercentAlive')}</th>
                        <th onClick={() => handleSort('duration')}>Duration {getSortIndicator('duration')}</th>
                        <th onClick={() => handleSort('localDPS')}>Local DPS {getSortIndicator('localDPS')}</th>
                        <th onClick={() => handleSort('percentDamage')}>% Damage {getSortIndicator('percentDamage')}</th>
                        <th onClick={() => handleSort('percentDead')}>% Dead {getSortIndicator('percentDead')}</th>
                        <th onClick={() => handleSort('logsStored')}>Logs Stored {getSortIndicator('logsStored')}</th>
                        <th onClick={() => handleSort('uniquePlayers')}>Unique Players {getSortIndicator('uniquePlayers')}</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedData.map((item, index) => (
                        <tr key={index}>
                            <td>{item.user}</td>
                            <td>{Math.round(item.score)}</td>
                            <td>{Math.round(item.clearPercent*100)/10}%</td>
                            <td>{Math.round(item.clearPercentAlive*100)/10}%</td>
                            <td>{Math.round(item.duration/360000)/10} Hours</td>
                            <td>{Math.round(item.localDPS/100000)/10} M</td>
                            <td>{Math.round(item.percentDamage*100)/10}%</td>
                            <td>{Math.round(item.percentDead*100)/10}%</td>
                            <td>{item.logsStored}</td>
                            <td>{item.uniquePlayers}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};

export default Leaderboard;
